import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'ProductPageBase',
})(({ spacing, breakpoints, brandColors, typography: { pxToRem }, type }) => ({
  container: {
    backgroundColor: brandColors.tintsOffWhite60,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: spacing(3),
    gap: 0,
    [breakpoints.up('md')]: {
      gap: pxToRem(40),
      flexDirection: 'row',
    },
    [breakpoints.up('lg')]: {
      gap: pxToRem(80),
    },
  },
  carouselContainer: {
    minWidth: 0,
    flex: 1,
  },
  productInformationContainer: {
    marginTop: pxToRem(24),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: spacing(2),
    [breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
  subheading: {
    marginTop: spacing(0),
  },
  disclaimer: {
    color: brandColors.tintsNeutral20,
    ...type['12_regular'],
    [breakpoints.up('sm')]: {
      ...type['14_regular'],
    },
    [breakpoints.up('lg')]: {
      ...type['16_regular'],
    },
  },
  checkoutButtons: {
    display: 'flex',
    width: '100%',
    gap: spacing(1),
  },
}));

export default useStyles;
